import { Reducer } from 'redux'
import { SplashScreenActionObjectTypes } from './actions'
import { SplashScreenActionTypes, SplashScreenState } from './types'

const initialSplashScreenState: SplashScreenState = {
  url: null,
  pendingUrl: null,
}

export const splashScreenReducer: Reducer<SplashScreenState, SplashScreenActionObjectTypes> = (state = initialSplashScreenState, action) => {
  switch (action.type) {
    case SplashScreenActionTypes.STORE_PENDING_SPLASH_SCREEN:
      return { ...state, pendingUrl: action.payload.url }
    case SplashScreenActionTypes.CONFIRM_SPLASH_SCREEN:
      return state.pendingUrl ? { url: state.pendingUrl, pendingUrl: null } : state
    case SplashScreenActionTypes.CLEAR_SPLASH_SCREEN:
      return initialSplashScreenState
    default:
      return state
  }
}
